import React from 'react';

import Panel from '@components/smartAdminUI/Panel';
import REMapListWidget from '@components/widget/REMapListWidget';

const REMapList = () => (
  <>
    <div className="subheader">
      <h1 className="subheader-title">
        <i className="subheader-icon fal fa-map mr-2" />
        REMapList™
      </h1>
    </div>
    <div className="row">
      <div className="col-lg-4 d-flex">
        <Panel customClass="w-100">
          <REMapListWidget />
        </Panel>
      </div>
    </div>
  </>
);

export default REMapList;
